export enum NotificationTypes {
    Success,
    Warning,
    Failed
}